import { Shield } from 'lucide-react';
import { useIamRoles, useDeleteIamRole, type IamRole } from '@/api/s3';
import { IamListPage } from '../IamListPage';

/** IAM roles — list, view (detail), create and delete. */
export function RoleList({ serviceId }: { serviceId: string }) {
  const { data = [], isLoading, isError, refetch } = useIamRoles(serviceId);
  const del = useDeleteIamRole(serviceId);

  return (
    <IamListPage<IamRole>
      serviceId={serviceId}
      resource="roles"
      title="Roles"
      description="IAM roles grant temporary access to whoever can assume them."
      createLabel="Create role"
      entities={data}
      isLoading={isLoading}
      isError={isError}
      refetch={refetch}
      nameOf={(r) => r.role_name}
      dateOf={(r) => r.create_date}
      emptyIcon={<Shield size={20} />}
      emptyTitle="No roles yet"
      emptyDescription="Create a role with a trust policy to delegate scoped, assumable access."
      del={del}
      entityLabel="role"
    />
  );
}
